function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import React, { useMemo } from 'react';
import SectionBuilder from "./SectionBuilder";
import sections from "./sections";
import useCountriesHook from "../../hooks/useCountries";
var EducationSummarySection = function EducationSummarySection(_ref) {
  var snapshot = _ref.snapshot,
    currentSnapshot = _ref.currentSnapshot,
    onCommit = _ref.onCommit,
    committedKeys = _ref.committedKeys;
  // TODO: change this to use useCountries from ~/data instead of ~/hooks
  var countries = useCountriesHook();
  var countryFormatter = React.useMemo(function () {
    if (!countries) {
      return function () {
        return '';
      };
    }
    var countryMap = new Map();
    countries.forEach(function (country) {
      countryMap.set(country.code, country.name);
    });
    return function (code) {
      return countryMap.get(code);
    };
  }, [countries]);
  var sectionKeys = useMemo(function () {
    var sectionData = sections['Education Summary'];
    var result = {};
    Object.keys(sectionData).forEach(function (key) {
      result[key] = _objectSpread({}, sectionData[key]);
      if (key === 'programApplication.applicant.educationSummary.countryOfEducation') {
        result[key].formatter = countryFormatter;
      }
    });
    return result;
  }, [countryFormatter]);
  if (!countries) return null;
  return /*#__PURE__*/React.createElement(SectionBuilder, {
    title: "Education Summary",
    sectionKeys: sectionKeys,
    snapshot: snapshot,
    currentSnapshot: currentSnapshot,
    onCommit: onCommit,
    committedKeys: committedKeys
  });
};
export default /*#__PURE__*/React.memo(EducationSummarySection);